import React from 'react';
import { hatchDotSpecs, hatchInk, hatchLineSpecs } from '../../utils/evmLegend';

/** Recharts bar shape: solid fill plus optional hash / hatch overlay (prints in the PDF). */
export function hatchedBarShape(pattern = 'solid') {
  function HatchedBar(props) {
    const { x, y, width, height, fill, fillOpacity = 1 } = props;
    if (!(width > 0 && height > 0)) return null;
    const clipId = [
      'evm-hatch',
      pattern,
      Math.round(x),
      Math.round(y),
      Math.round(width),
      Math.round(height)
    ].join('-');
    const ink = hatchInk(fill);
    const lines = hatchLineSpecs(pattern, x, y, width, height);
    const dots = hatchDotSpecs(pattern, x, y, width, height);
    return (
      <g opacity={fillOpacity}>
        <rect x={x} y={y} width={width} height={height} fill={fill} />
        {(lines.length > 0 || dots.length > 0) && (
          <>
            <defs>
              <clipPath id={clipId}>
                <rect x={x} y={y} width={width} height={height} />
              </clipPath>
            </defs>
            <g clipPath={`url(#${clipId})`} pointerEvents="none">
              {lines.map((line, i) => (
                <line
                  key={`l${i}`}
                  x1={line.x1}
                  y1={line.y1}
                  x2={line.x2}
                  y2={line.y2}
                  stroke={ink}
                  strokeWidth={1.25}
                />
              ))}
              {dots.map((dot, i) => (
                <circle key={`d${i}`} cx={dot.cx} cy={dot.cy} r={1.05} fill={ink} />
              ))}
            </g>
          </>
        )}
      </g>
    );
  }
  return HatchedBar;
}
